import { courtService } from "../_services";


export default {
  namespaced: true,


  state: {
    courts: [],
    court: "",
    alias: "",
    stamp: ""
  },

  mutations: {
    setCourts: (state, payload) => {
      state.courts = payload
    },

    setCourt: (state, payload) => {
      state.court = payload
    },
    setAlias: (state, payload) => {
      state.alias = payload
    }
  },
  actions: {
    INIT: ({ dispatch }) => {
      dispatch('LOAD_COURT')
    },

    LOAD_COURT: ({ commit }) => {
      courtService.getCourt().then(data => {
        commit('setCourts', data)
        commit('setCourt', data[0])
      })
    },
  }
}